// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__aFQLT","title":"ModalHeader_title__YCvj1","button":"ModalHeader_button__esUY-"};